import jwtDecode from 'jwt-decode';
// routes
import { PATH_AUTH } from '../routes/paths';

// ----------------------------------------------------------------------

const isValidToken = (access) => {
  if (!access) {
    return false;
  }
  try {
    const decoded = jwtDecode(access);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (error) {
    return false;
  }
};

const getRefreshToken = () => localStorage.getItem('refresh');

const setSession = (access, refresh = null) => {
  if (access) {
    localStorage.setItem('access', access);

    if (refresh) {
      localStorage.setItem('refresh', refresh);
    }
  } else {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
  }
};

const clearSession = () => {
  localStorage.removeItem('access');
  localStorage.removeItem('refresh');
  window.location.href = PATH_AUTH.login;
};

export { isValidToken, setSession, getRefreshToken, clearSession };
